import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpCommonService } from 'src/app/shared/services/http-common-service';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { SelectList } from '../../../shared/models/select-list';
import { MeetingAddEditDto, MeetingDashboard, MeetingDto, SearchMeetingDto, MeetingsSummaryDto } from '../models/meeting-models';

@Injectable({
    providedIn: 'root'
})
export class MeetingService {
    baseUrl = 'Meeting';
    constructor(private httpCommonService: HttpCommonService) {
    }

    getDashboard(): Observable<ApiResponse<MeetingDashboard>> {
      return this.httpCommonService.get<ApiResponse<MeetingDashboard>>({
            url: this.baseUrl + "/GetDashboard"
        });
    }

    search(model: SearchMeetingDto): Observable<ApiResponse<SearchMeetingDto>> {
        return this.httpCommonService.post<ApiResponse<SearchMeetingDto>>({
            url: this.baseUrl + "/Search",
            body: model
        });
    }

    getById(id: string): Observable<ApiResponse<MeetingDto>> {
        return this.httpCommonService.get<ApiResponse<MeetingDto>>({
            url: this.baseUrl + "/Get/" + id
        });
    }

    save(model: MeetingAddEditDto): Observable<ApiResponse<string>> {
        return this.httpCommonService.post<ApiResponse<string>>({
            url: this.baseUrl + "/Save",
            body: model
        });
    }

    delete(id: string): Observable<ApiResponse<string>> {
        return this.httpCommonService.delete<ApiResponse<string>>({
            url: this.baseUrl + "/Delete/" + id
        });
    }

    updateStatus(id: string, statusId: number): Observable<ApiResponse<boolean>> {
        return this.httpCommonService.post<ApiResponse<boolean>>({
            url: this.baseUrl + "/UpdateStatus",
            body: { id: id, statusId: statusId }
        });
    }

    getSelectList(): Observable<ApiResponse<SelectList[]>> {
        return this.httpCommonService.get<ApiResponse<SelectList[]>>({
            url: this.baseUrl + "/GetSelectList"
        });
  }


  export(searchObjVM: SearchMeetingDto): Observable<Blob> {
    return this.httpCommonService.post({ url: this.baseUrl + "/Export", body: searchObjVM, responseType: 'blob' });
  }

  saveAttendance(attendanceData: any): Observable<ApiResponse<boolean>> {
    return this.httpCommonService.post<ApiResponse<boolean>>({
      url: this.baseUrl + "/SaveAttendance",
      body: attendanceData
    });
  }

    getSummary(topN: number = 5): Observable<ApiResponse<MeetingsSummaryDto>> {
        return this.httpCommonService.get<ApiResponse<MeetingsSummaryDto>>({
            url: this.baseUrl + "/GetSummary?topN=" + topN
        });
    }

    downloadMeetingMinutes(meetingId: string): Observable<Blob> {
        return this.httpCommonService.get({
            url: this.baseUrl + "/DownloadMeetingMinutes/" + meetingId,
            responseType: 'blob'
        });
    }
}
